import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            有问必答
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            关于每日大赛黑料网，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="rounded-lg bg-background-100 border border-background-300/50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer transition-colors hover:bg-background-200/50"
                onClick={() => setOpenId(openId === faq.id ? 0 : faq.id)}
              >
                <h3 className="text-foreground-200 font-medium text-sm md:text-base pr-4 font-heading">
                  {faq.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-300 flex-shrink-0 ${
                    openId === faq.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}